export const enumDataStrategyCreative = {
  videoKey: "video",
  searchKey: "search",
  displayKey: "display",
  displayVideoKey:"displayVideo",
  ads: {
    key: "ads",
  },
  viads: {
    key: "viads",
  },
  meta: {
    key: "meta",
  },
  dv360: {
    key: "dv360",
  },
  tiktok: {
    key: "tiktok",
  },
  ion: {
    key: "ion",
  },
  ioh: {
    key: "ioh",
  },
};

export const platformConfig = {
  google: "Google Ads",
  beki: "beki",
  ion: "ION",
  meta: "Meta",
  dv360: "DV360",
  tiktok: "TikTok",
  viads: "ViAds",
  ioh: "IOH"
};

export const dataStrategy = {
  ads: {
    display: [
      {
        name: "ADS strategy 1 sdtstystdb d udsi di",
        id: 12,
        creatives: [
          {
            value: 1,
            id: 1000,
            label: "Creative 1",
            title: "Creative 1",
            description:
              " Lorem ipsum dolor sit amet, cons ect etur adipisicing elit.",
            tags: ["Tag1", "Tag2", "Tag3", "Tag4"],
            mediaList: [
              {
                id: 1234,
                url: "https://images.unsplash.com/photo-1578927536491-054135f30c5a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fHNvdXJjZXxlbnwwfHwwfHx8MA%3D%3D",
              },
              {
                id: 12345,
                url: "https://images.unsplash.com/photo-1519068737630-e5db30e12e42?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c291cmNlfGVufDB8fDB8fHww",
              },
            ],
          },
          {
            value: 10001,
            id: 5,
            label: "creative 3",
            title: "Creative 2 Creative 2 Creative 2 Creative 2",
            description:
              " Lorem ipsum dolor sit amet, cons ect etur adipisicing elit.",
            tags: ["Tag_1_tag_new", "Tag2", "Tag3"],
            mediaList: [
              {
                id: 3455,
                url: "https://images.unsplash.com/photo-1490109875367-0dbd3c96fa1c?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
              },
            ],
          },
        ],
      },
      {
        name: "ADS strategy 2",
        id: 13,
        creatives: [
          {
            value: 1,
            id: 6,
            label: "Creative 1",
            title: "Creative 1",
            mediaList: [
              {
                id: 1234,
                url: "https://images.unsplash.com/photo-1578927536491-054135f30c5a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fHNvdXJjZXxlbnwwfHwwfHx8MA%3D%3D",
              },
              {
                id: 12345,
                url: "https://images.unsplash.com/photo-1519068737630-e5db30e12e42?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c291cmNlfGVufDB8fDB8fHww",
              },
            ],
          },
        ],
      },
      {
        name: "ADS strategy 4",
        id: 134,
        creatives: [
          {
            id: 7,
            value: 1,
            label: "Creative 1",
            title: "Creative 1",
            mediaList: [
              {
                id: 1234,
                url: "https://images.unsplash.com/photo-1578927536491-054135f30c5a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fHNvdXJjZXxlbnwwfHwwfHx8MA%3D%3D",
              },
              {
                id: 12345,
                url: "https://images.unsplash.com/photo-1519068737630-e5db30e12e42?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c291cmNlfGVufDB8fDB8fHww",
              },
            ],
          },
        ],
      },
    ],
    search: [
      {
        name: "ADS strategy 3",
        id: 18,
        creatives: [
          {
            value: 3,
            label: "creative 3",
            title: "creative 3",
            tags: ["Tag1", "Tag2", "Tag3", "Tag4"],
            landingUrl: "www.google.com",
            heading: ["Heading Heading Heading Headyy"],
            description: [

              "Heading Heading Heading HeadyyHeading Heading Heading HeadyyHeading Heading Heading Headyy",
            ],
          },
        ],
      },
    ],
  },
  meta: {
    display: [
      {
        name: "ADS strategy 3",
        id: 14,
        creatives: [
          {
            id: 4,
            value: 2,
            label: "creative 2",
            title: "creative 2",
            mediaList: [
              {
                id: 3455,
                url: "https://images.unsplash.com/photo-1555952494-efd681c7e3f9?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjZ8fHNvdXJjZXxlbnwwfHwwfHx8MA%3D%3D",
              },
            ],
          },
        ],
      },
    ],
    video: [
      {
        name: "Ads strategy video",
        id: 19,
        creatives: [
          {
            value: 2,
            id: 5,
            label: "creative Video",
            title: "creative Video",
            description:
              " Lorem ipsum dolor sit amet, cons ect etur adipisicing elit.",
            tags: ["Tag1", "Tag2", "Tag3", "Tag4"],
            mediaList: [
              {
                id: 34554,
                url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
              },
              {
                id: 345546,
                url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4",
              },
            ],
          },
          {
            value: 7,
            id: 9,
            label: "creative Video",
            title: "creative Video",
            description:
              " Lorem ipsum dolor sit amet, cons ect etur adipisicing elit.",
            tags: ["Tag1", "Tag2", "Tag3", "Tag4"],
            mediaList: [
              {
                id: 345546,
                url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4",
              },
            ],
          }
        ],
      },
    ],
  },
  dv360: {
    display: [
      {
        name: "ADS strategy 3",
        id: 14,
        creatives: [
          {
            id: 4,
            value: 2,
            label: "creative 2",
            title: "creative 2",
            mediaList: [
              {
                id: 3455,
                url: "https://images.unsplash.com/photo-1555952494-efd681c7e3f9?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjZ8fHNvdXJjZXxlbnwwfHwwfHx8MA%3D%3D",
              },
            ],
          },
        ],
      },
    ],
    video: [],
  },
};

// {
//   ads: {
//     display: [
//       {
//         name: "ADS strategy 1",
//         id: 12,
//         creatives: [],
//       },
//       {
//         name: "ADS strategy 2",
//         id: 13,
//         creatives: [],
//       },
//     ],
//     search: [
//       {
//         name: "ADS strategy 3",
//         id: 14,
//         creatives: [],
//       },
//     ],
//   },
//   meta: {
//     display: [
//       {
//         name: "ADS strategy 4",
//         id: 14,
//         creatives: [],
//       },
//     ],
//     video: [
//       {
//         name: "ADS strategy 5",
//         id: 15,
//         creatives: [],
//       },
//     ],
//   },
//   dv360: {
//     display: [
//       {
//         name: "ADS strategy 6",
//         id: 16,
//         creatives: [],
//       },
//     ],
//     video: [],
//   },
// }
